module.exports = "/images/69a7c47d7a2eaac7b08729a952138a34.svg";